module.exports = __webpack_public_path__ + "img/icone_studio_industrie.e3c1a4eb.png";